import { Link } from '@huntington/honeycomb';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import {
  API_ERROR_PAGE_DESCRIPTION_PREFIX,
  API_ERROR_PAGE_DESCRIPTION_PREFIX_MOBILE,
  API_ERROR_PAGE_DESCRIPTION_SUFFIX,
  API_ERROR_PAGE_DESCRIPTION_SUFFIX_MOBILE,
  API_ERROR_PAGE_TITLE,
  CIRCADIA_HELP_EMAIL,
} from '../../constants/messages';
import EnrollmentHeader from '../Enrollment/EnrollmentHeader/EnrollmentHeader';
import Footer from '../Footer/Footer';

function RootErrorBoundary() {
	const isTabletOrMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
	const error = useRouteError();

	const isRouteError = isRouteErrorResponse(error);

	return (
		<Box
			sx={{
				backgroundColor: 'background.paper',
				display: 'flex',
				flexDirection: 'column',
				minHeight: '100vh',
				width: '100vw',
				pt: 0,
				mt: 0,
			}}
		>
			<EnrollmentHeader />
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					height: '100%',
					position: 'relative',
				}}
			>
				<Box
					sx={{
						backgroundColor: 'surface.tertiary',
						position: 'absolute',
						width: '100%',
						height: { xs: '2rem', md: '22.25rem' },
					}}
				/>
				<Box
					sx={{
						backgroundColor: 'background.paper',
						margin: {
							xs: '2rem auto 0',
							md: '2.5rem auto 0',
						},
						maxWidth: '35.75rem',
						padding: '2.5rem 2.5rem 5rem',
						position: 'relative',
					}}
				>
					<Typography
						component="h1"
						variant="h1"
						fontWeight={700}
						fontSize={{ xs: '1.5rem', md: '2.25rem' }}
						fontFamily='"Huntington Serif", serif'
					>
						{isRouteError ? `${error.status} ${error.statusText}` : API_ERROR_PAGE_TITLE}
					</Typography>
					<Typography pt={{ xs: '1.5rem', md: '2rem' }} pb="2.5rem">
						{isTabletOrMobile
							? API_ERROR_PAGE_DESCRIPTION_PREFIX_MOBILE
							: API_ERROR_PAGE_DESCRIPTION_PREFIX}
						<Link href={`mailto:${CIRCADIA_HELP_EMAIL}`}>{CIRCADIA_HELP_EMAIL}</Link>
						{isTabletOrMobile
							? API_ERROR_PAGE_DESCRIPTION_SUFFIX_MOBILE
							: API_ERROR_PAGE_DESCRIPTION_SUFFIX}
					</Typography>
				</Box>
			</Box>
			<Footer />
		</Box>
	);
}

export default RootErrorBoundary;
